import { render, staticRenderFns } from "./testWS.vue?vue&type=template&id=3e537b52&"
import script from "./testWS.vue?vue&type=script&lang=js&"
export * from "./testWS.vue?vue&type=script&lang=js&"
import style0 from "./testWS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports